import script from "./SelectCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCompany.vue?vue&type=script&setup=true&lang=js"

import "./SelectCompany.vue?vue&type=style&index=0&id=5343334f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5343334f"]])

export default __exports__